import {
  DASHBOARD_SHARED_URL,
  DASHBOARD_TYPE,
  DASHBOARD_URL,
  HOME_LONG_PATH,
  TEMP_DASHBOARD_URL,
} from '@utils/constants';
import { getAppFlowIdFromUsecaseKey, isAppFlowPresetUsecaseKey } from '@utils/preset';

const { baseUrl } = window.conviva;

export const getViewerModuleNewTabUrl = (vid) => `${baseUrl}/dashboard/viewer-module/${vid}`;

export const getViewerModuleTempDashboardUrl = (vid, id) =>
  `${baseUrl}/dashboard/viewer-module/${vid}/temp/${id}`;

export const getAppViewerModuleTempDashboardUrl = (queryParams, id) => {
  let search = '';
  const { viewerId, clientId, interval, source, key, type, sessionId, flowId } = queryParams;
  if (clientId) {
    search = `clientId=${encodeURIComponent(clientId)}`;
  }
  if (viewerId) {
    search = `userId=${encodeURIComponent(viewerId)}`;
  }
  if (clientId && viewerId) {
    search = `userId=${encodeURIComponent(viewerId)}&clientId=${encodeURIComponent(clientId)}`;
  }
  if (interval) {
    // Convert interval to ISO format
    const [from, to] = interval.split('/');

    const fromISO = new Date(from).toISOString();
    const toISO = new Date(to).toISOString();

    const newISOString = fromISO + '/' + toISO;

    search = `${search}&interval=${newISOString}`;
  }
  if (source) {
    search = `${search}&source=${encodeURIComponent(source)}`;
  }
  if (key) {
    search = `${search}&key=${encodeURIComponent(key)}`;
  }
  if (type) {
    search = `${search}&type=${type}`;
  }
  if (sessionId) {
    search = `${search}&sessionId=${sessionId}`;
  }
  if (flowId) {
    search = `${search}&flowId=${flowId}`;
  }
  return `${baseUrl}/dashboard/user-timeline/temp/${id}?${search}`;
};

// moved logic from temp dashboard and added viewer scenario
// temp approach until we can revamp temp dashboards to support url params
function getTempDashboardUrl(tabStore, { isSharing, isSaved, id }) {
  const { dashboardTypeId, type, dashboard } = tabStore;
  let url = HOME_LONG_PATH;
  const typeId = dashboardTypeId || type;

  switch (true) {
    case isSharing:
      url =
        typeId === DASHBOARD_TYPE.VIEWER_MODULE
          ? `${DASHBOARD_SHARED_URL[typeId]}${dashboard.vmStore.viewerId}/sharing/${id}`
          : `${DASHBOARD_SHARED_URL[typeId]}${id}`;
      break;
    case isSaved && typeId in DASHBOARD_URL:
      url =
        typeId === DASHBOARD_TYPE.VIEWER_MODULE
          ? `${DASHBOARD_URL[typeId]}${id}`
          : `${DASHBOARD_URL[typeId]}${id}`;
      break;
    case typeId in TEMP_DASHBOARD_URL:
      if (typeId === DASHBOARD_TYPE.VIEWER_MODULE) {
        url = getViewerModuleTempDashboardUrl(dashboard.viewerId, id);
      } else if (typeId === DASHBOARD_TYPE.APP_VIEWER_MODULE) {
        url = getAppViewerModuleTempDashboardUrl(
          { viewerId: dashboard.viewerId, clientId: dashboard.clientId, flowId: dashboard.flowId },
          id,
        );
      } else if (isAppFlowPresetUsecaseKey(dashboard.usecaseKey)) {
        url = `${TEMP_DASHBOARD_URL[typeId]}${id}?flowId=${getAppFlowIdFromUsecaseKey(dashboard.usecaseKey)}`;
      } else {
        url = `${TEMP_DASHBOARD_URL[typeId]}${id}`;
      }
      break;
    default:
      break;
  }

  return url;
}

export default getTempDashboardUrl;
